import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
function EmptyFavoriteCard() {
  const $ = _c(4);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("profile.empty-favorite-card.description");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="bg-secondary-normal flex h-[269px] w-full flex-col items-center justify-center gap-5 rounded-2xl p-4"><p className="body text-center text-sm md:text-base">{t0}</p></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default EmptyFavoriteCard;